import type React from "react";
import type { ConnectionRequestSummary } from "@shared/schemas/connection-request.schemas";
import type {
  EventIdPublicOrSlug,
  EventParticipantIdPublic,
} from "@shared/schemas/branded-id.schemas";
import { useConnectionRequestCardController } from "../../controllers/useConnectionRequestCardController";
import { ConnectionRequestCard } from "./ConnectionRequestCard";

interface ConnectionRequestCardContainerProps {
  readonly request: ConnectionRequestSummary;
  readonly eventIdPublicOrSlug: EventIdPublicOrSlug;
  readonly onViewProfile: (
    participantIdPublic: EventParticipantIdPublic,
  ) => void;
}

/**
 * Row-level wiring shell. React requires the per-request hook to be invoked once per
 * row, so this component exists only to call `useConnectionRequestCardController` and
 * hand its result to the presentational `ConnectionRequestCard` — no logic of its own.
 */
export function ConnectionRequestCardContainer({
  request,
  eventIdPublicOrSlug,
  onViewProfile,
}: ConnectionRequestCardContainerProps): React.JSX.Element {
  const { onAccept, onIgnore, isAccepting, isIgnoring } =
    useConnectionRequestCardController(request, eventIdPublicOrSlug);

  return (
    <ConnectionRequestCard
      request={request}
      onAccept={onAccept}
      onIgnore={onIgnore}
      onViewProfile={onViewProfile}
      isAccepting={isAccepting}
      isIgnoring={isIgnoring}
    />
  );
}
